<ui-modal
  [isOpened]="modalOpened"
  modalTitle="Historical portfolio"
  (isOpenedChange)="modalChanged($event)"
  class="load-portfolio-modal"
  size="md"
>
  <form [formGroup]="form">
    <clr-date-container>
      <label>Date</label>
      <input
        class="input-date"
        type="date"
        clrDate
        [placeholder]="'DD MMM YYYY'"
        [inputValidator]="['dateShorthand']"
        [required]="true"
        [formControlName]="'date'"
        autocomplete="off"
      />
    </clr-date-container>
    <clr-input-container>
      <label>Time</label>
      <input
        type="text"
        clrInput
        [placeholder]="'HH:MM:SS'"
        [inputValidator]="['hhmmss']"
        [required]="true"
        [formControlName]="'time'"
        autocomplete="off"
      />
    </clr-input-container>
    <clr-select-container>
      <label>Timezone</label>
      <select clrSelect name="options" [formControlName]="'timezone'">
        <option *ngFor="let tz of timezones" [value]="tz">
          {{ tz }}
        </option>
      </select>
    </clr-select-container>
    <div class="footer-buttons">
      <button
        type="button"
        class="ui-button ui-button__footer load-btn"
        [disabled]="state === 'LOADING' || !form.valid"
        (click)="load()"
        *ngIf="state !== 'LOADING'"
      >
        Load
      </button>
      <span *ngIf="state === 'LOADING'"> Loading... </span>
    </div>
  </form>
</ui-modal>
